export function dataInRequest(params = {}) {
  return {
    type: '@corredor/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@corredor/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@corredor/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@corredor/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@corredor/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@corredor/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@corredor/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@corredor/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@corredor/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@corredor/RECORD_FILTERING',
    payload: { params },
  };
}
